// extracted by mini-css-extract-plugin
module.exports = {"large":"styles_large__WroO2","medium":"styles_medium__tEtab","small":"styles_small__751z1"};